/* ============================================================
   DW Chrome — scroll-collapse, drawers (mobile menu, mini cart)
   Loaded site-wide. Listens to scroll + delegated click events.
   ============================================================ */

(function () {
  'use strict';

  // Signal to the section's inline self-check that chrome.js is alive,
  // so it doesn't fire its fallback drawer toggle.
  window.DwChromeReady = true;
  console.log('%c[DW] chrome.js loaded — build: scrim-2', 'color:#1A9E3E;font-weight:bold');

  // ---- iOS :active enabler ----
  // Safari only applies :active to natively-clickable elements (<a>, <button>)
  // or where a touch handler exists in the ancestry. .dw-product-card is an
  // <article> (snippets/dw-product-card.liquid), so the whole card press system
  // at the end of dw-components.css NEVER fired on iPhone — those users got the
  // sticky hover state on tap and no press at all.
  //
  // Registering one empty, passive, document-level touchstart listener is the
  // documented opt-in. It has no handler body, so it costs nothing per event and
  // cannot block scrolling.
  document.addEventListener('touchstart', function () {}, { passive: true });

  /* ============================================================
     DW MOTION RUNTIME — one gate, haptics, sound, particles
     ============================================================
     Everything decorative on the site asks this module for permission first, so
     there is exactly one place to turn the whole programme down: Theme settings
     → Animations → Motion level (emitted as data-dw-motion on <html>).

       full       presses + reveals + reward moments   (default)
       essential  presses + reveals, no celebrations
       off        nothing — same as OS reduce-motion

     A visitor's OS preference always wins over the shop setting; we can ask for
     less motion than they allow, never more.
     ============================================================ */
  var DwMotion = (function () {
    var root = document.documentElement;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var level = root.getAttribute('data-dw-motion') || 'full';
    if (reduced) level = 'off';

    return {
      level: level,
      // Presses, reveals, transitions — the things that make the UI legible.
      essential: level !== 'off',
      // Bursts, foam, count-ups, shine — the things that are purely a reward.
      celebrate: level === 'full',
    };
  })();
  window.DwMotion = DwMotion;

  /* ---- Haptics -------------------------------------------------------------
     Android only — iOS Safari does not implement navigator.vibrate at all, so
     nothing may ever depend on this firing. Commit actions only: never on
     hover, scroll, reveal or navigation. A phone that buzzes while you scroll a
     catalogue gets the site closed. */
  var DwTap = (function () {
    var canVibrate = typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
    var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var optedOut = false;
    try { optedOut = window.localStorage.getItem('dw_haptics') === 'off'; } catch (e) {}

    var PATTERNS = {
      tap: 8,               // committed: added to cart, filter applied
      deny: 24,             // refused: hit the stock cap
      reward: [0, 12, 40, 12], // earned: threshold unlocked, tier reached
    };

    return function dwTap(kind) {
      if (!canVibrate || !isTouch || optedOut) return;
      if (!DwMotion.essential) return;
      try { navigator.vibrate(PATTERNS[kind] || PATTERNS.tap); } catch (e) {}
    };
  })();
  window.DwTap = DwTap;

  /* ---- Sound ---------------------------------------------------------------
     Lifted verbatim from dw-arcade-2d.js so the storefront and the arcade share
     one implementation. Oscillator-based: no audio files, no network requests.
     The AudioContext is built lazily on first use, which is what keeps it
     compliant with browser autoplay policy.

     MUTED BY DEFAULT on the storefront, and it should stay that way — a shop
     that beeps unprompted gets muted at the OS level and reads as spam. The
     arcade is different: pressing "Play — 1 token" is explicit consent. */
  var DwSfx = (function () {
    function makeSfx() {
      var ctx = null, ok = true;
      function ac() {
        if (ctx) return ctx;
        if (!ok) return null;
        try { ctx = new (window.AudioContext || window.webkitAudioContext)(); }
        catch (e) { ok = false; return null; }
        return ctx;
      }
      function tone(freq, dur, type, gain, slideTo) {
        var c = ac(); if (!c) return;
        try {
          if (c.state === 'suspended') c.resume();
          var o = c.createOscillator(), g = c.createGain(), t = c.currentTime;
          o.type = type || 'square'; o.frequency.setValueAtTime(freq, t);
          if (slideTo) o.frequency.exponentialRampToValueAtTime(Math.max(1, slideTo), t + dur);
          g.gain.setValueAtTime(gain || 0.04, t);
          g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
          o.connect(g); g.connect(c.destination);
          o.start(t); o.stop(t + dur + 0.02);
        } catch (e) {}
      }
      return {
        select: function () { tone(760, 0.07, 'square', 0.05); },
        deny:   function () { tone(190, 0.22, 'sawtooth', 0.05, 90); },
        whirr:  function () { tone(110, 0.55, 'sawtooth', 0.035, 220); },
        thunk:  function () { tone(70, 0.26, 'square', 0.07, 46); tone(150, 0.1, 'square', 0.04); },
        take:   function () { tone(660, 0.08, 'square', 0.05); tone(990, 0.12, 'square', 0.05); },
        tick:   function () { tone(1180, 0.025, 'square', 0.03); },
        win:    function () { tone(523, 0.1, 'square', 0.05); tone(784, 0.12, 'square', 0.05); tone(1047, 0.2, 'square', 0.05); },
        close:  function () { if (ctx) { try { ctx.close(); } catch (e) {} ctx = null; } }
      };
    }

    var shop = document.documentElement.getAttribute('data-dw-sound') === 'allowed';
    var enabled = shop;
    try {
      var saved = window.localStorage.getItem('dw_sound');
      if (saved === 'on') enabled = true;
      if (saved === 'off') enabled = false;
    } catch (e) {}

    var inst = null;
    function play(name) {
      if (!enabled || !DwMotion.celebrate) return;
      if (!inst) inst = makeSfx();
      if (inst[name]) inst[name]();
    }

    return {
      make: makeSfx,                       // the arcade borrows the factory
      isEnabled: function () { return enabled; },
      setEnabled: function (v) {
        enabled = !!v;
        try { window.localStorage.setItem('dw_sound', enabled ? 'on' : 'off'); } catch (e) {}
      },
      select: function () { play('select'); },
      deny:   function () { play('deny'); },
      take:   function () { play('take'); },
      tick:   function () { play('tick'); },
      win:    function () { play('win'); },
    };
  })();
  window.DwSfx = DwSfx;

  /* ---- Particle burst ------------------------------------------------------
     One reusable effect behind three separate moments (add to cart, threshold
     unlocked, easter egg). Each particle carries its own --angle/--dist custom
     properties — the same per-instance pattern the polaroids use for --lift and
     --tilt — so a single @keyframes covers every direction.

     transform + opacity only, self-removing on animationend, and the node is
     appended to <body> so it can never be clipped by an ancestor's
     overflow: hidden (which is exactly what would eat it on a .dw-btn). */
  function dwBurst(anchor, opts) {
    if (!DwMotion.celebrate || !anchor) return;
    opts = opts || {};
    var count = opts.count || 8;
    var rect = anchor.getBoundingClientRect();
    if (!rect.width && !rect.height) return;

    var host = document.createElement('div');
    host.className = 'dw-burst' + (opts.variant ? ' dw-burst--' + opts.variant : '');
    host.style.left = rect.left + rect.width / 2 + 'px';
    host.style.top = rect.top + rect.height / 2 + 'px';

    for (var i = 0; i < count; i++) {
      var p = document.createElement('i');
      // Spread evenly, then jitter, so it reads as scatter rather than a clock face.
      var angle = (360 / count) * i + (Math.random() * 24 - 12);
      p.style.setProperty('--angle', angle + 'deg');
      p.style.setProperty('--dist', 28 + Math.random() * 34 + 'px');
      p.style.setProperty('--delay', Math.random() * 60 + 'ms');
      host.appendChild(p);
    }

    document.body.appendChild(host);
    var done = false;
    function cleanup() { if (done) return; done = true; if (host.parentNode) host.parentNode.removeChild(host); }
    host.addEventListener('animationend', cleanup, { once: true });
    setTimeout(cleanup, 1200); // safety net if animationend never fires
  }
  window.DwBurst = dwBurst;

  // ---- Scroll-collapse header — shift-free, jitter-proof, direction-aware ----
  //
  // The old failure mode: .dw-header-wrap is `position: sticky` and lives in
  // normal flow, so collapsing the utility bar + nav shrank its flow box and
  // yanked <main> upward (the "page shift"). That height change also moved the
  // scroll range, so scrollY could snap back across the threshold and re-toggle
  // forever (the "jitter"). On short pages there was barely any room to scroll,
  // so the collapse fired abruptly (the "jarring" jump).
  //
  // Root-cause fix: PIN the wrap's flow height to its expanded size via an
  // inline min-height. Now collapsing the chrome never changes document height
  // — zero shift, and with no height change there is no feedback loop to drive
  // the jitter. The freed space inside the wrap is made transparent + click-
  // through in CSS so there's no empty bar and content underneath stays usable.
  const wrap = document.getElementById('DwHeaderWrap');

  // Hysteresis band: must pass COLLAPSE_AT (downward) to hide, must return above
  // EXPAND_AT (near the top) to restore. The wide, non-overlapping gap means a
  // few px of scroll noise at either edge can never flip the state.
  const COLLAPSE_AT = 150;
  const EXPAND_AT = 50;
  // Ignore micro-scrolls so a trackpad/touch jiggle never registers as intent.
  const MIN_DELTA = 6;
  // Don't collapse unless there's real room to scroll. Fixes the jarring hide
  // on sparse product/empty pages — short pages simply keep the full header.
  const MIN_SCROLLABLE = 280;

  let isCollapsed = false;
  // Start from 0 so a restored-scroll load (page reopened part-way down) reads
  // as a downward scroll on the first frame and collapses correctly.
  let lastY = 0;
  let reserve = 0;
  let scrollRaf = 0;

  // Measure & pin the expanded header height. Only valid while expanded, so the
  // collapsed (shorter) height never gets captured as the reserve.
  function measureReserve() {
    if (!wrap || isCollapsed) return;
    const h = wrap.offsetHeight;
    if (h && Math.abs(h - reserve) > 1) {
      reserve = h;
      wrap.style.minHeight = reserve + 'px';
    }
  }

  function setCollapsed(next) {
    if (next === isCollapsed) return;
    isCollapsed = next;
    document.body.classList.toggle('is-scrolled', next);
    // After expanding, the nav/logo settle back — re-measure on the next frame
    // so the pinned height tracks any layout/responsive change.
    if (!next) requestAnimationFrame(measureReserve);
  }

  function update() {
    scrollRaf = 0;
    const y = window.scrollY || 0;
    const dy = y - lastY;
    lastY = y;

    // Not enough page to scroll → never collapse (and undo if we somehow had).
    const scrollable =
      (document.documentElement.scrollHeight || 0) - window.innerHeight;
    if (scrollable < MIN_SCROLLABLE) {
      setCollapsed(false);
      return;
    }

    if (!isCollapsed) {
      // Collapse only while actively scrolling DOWN past the threshold.
      if (y > COLLAPSE_AT && dy > MIN_DELTA) setCollapsed(true);
    } else {
      // Restore only near the top — calm, predictable, can't ping-pong.
      if (y < EXPAND_AT) setCollapsed(false);
    }
  }

  function onScroll() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    // Re-pin on viewport changes (orientation, responsive breakpoints).
    if (!isCollapsed) measureReserve();
  });
  if ('ResizeObserver' in window && wrap) {
    new ResizeObserver(function () {
      if (!isCollapsed) measureReserve();
    }).observe(wrap);
  }
  // Initial measurement: now, after load (fonts/logo image can change height).
  measureReserve();
  window.addEventListener('load', measureReserve);
  onScroll();

  // ---- Body scroll lock (overflow-based, doesn't break sticky) ----
  let scrollLockCount = 0;
  let savedPaddingRight = '';
  function lockBodyScroll() {
    if (scrollLockCount === 0) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      savedPaddingRight = document.body.style.paddingRight;
      if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
      document.documentElement.style.overflow = 'hidden';
    }
    scrollLockCount++;
  }
  function unlockBodyScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.documentElement.style.overflow = '';
      document.body.style.paddingRight = savedPaddingRight;
    }
  }

  // ---- Drawer system (delegated click handling) ----
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return false;
    document.body.classList.add('has-open-drawer');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
    const focusable = drawer.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) setTimeout(() => focusable.focus(), 60);
    if (id === 'DwCartDrawer') refreshCartDrawer();
    dwShowScrim(drawer);
    return true;
  }

  // ---- Bulletproof page dim + click-off ----
  // The in-markup .dw-drawer__backdrop was being collapsed (0x0 / display:none)
  // somewhere in the CSS cascade, so it dimmed nothing and caught no clicks.
  // Instead of fighting that, we build a scrim from scratch, append it straight
  // to <body> (no section-wrapper ancestors) and style it inline with
  // !important so no stylesheet can hide or resize it. We also make the drawer
  // aside click-through except for its panel, so clicks on the dimmed area land
  // on the scrim and close the drawer.
  // z-index strategy mirrors the proven old mini-cart: go astronomically high so
  // nothing on the page can paint over the scrim. The drawer sits one above it.
  var DW_SCRIM_Z = 2147483646;
  var DW_DRAWER_Z = 2147483647;
  var dwScrim = null;
  function dwGetScrim() {
    if (dwScrim && document.body.contains(dwScrim)) return dwScrim;
    dwScrim = document.createElement('div');
    dwScrim.className = 'dw-scrim';
    dwScrim.setAttribute('aria-hidden', 'true');
    var css =
      'position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;' +
      'background:rgba(20,22,26,0.68);z-index:' + DW_SCRIM_Z + ';opacity:0;' +
      'transition:opacity 280ms ease;pointer-events:none;cursor:pointer;' +
      '-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);';
    css.split(';').forEach(function (decl) {
      if (!decl) return;
      var i = decl.indexOf(':');
      dwScrim.style.setProperty(decl.slice(0, i).trim(), decl.slice(i + 1).trim(), 'important');
    });
    dwScrim.addEventListener('click', closeAllDrawers);
    document.body.appendChild(dwScrim);
    return dwScrim;
  }
  function dwShowScrim(drawer) {
    // Hide the broken in-markup backdrop so it can never double-dim.
    var bd = drawer.querySelector('.dw-drawer__backdrop');
    if (bd) bd.style.setProperty('display', 'none', 'important');
    // Lift the drawer above the scrim, and let clicks fall through the bare
    // aside to the scrim while keeping the panel itself interactive.
    drawer.style.setProperty('z-index', String(DW_DRAWER_Z), 'important');
    drawer.style.setProperty('pointer-events', 'none', 'important');
    var panel = drawer.querySelector('.dw-drawer__panel');
    if (panel) panel.style.setProperty('pointer-events', 'auto', 'important');

    var s = dwGetScrim();
    s.style.setProperty('pointer-events', 'auto', 'important');
    void s.offsetWidth; // reflow so the opacity transition runs from 0 -> 1
    s.style.setProperty('opacity', '1', 'important');
  }
  function dwHideScrim() {
    if (!dwScrim) return;
    dwScrim.style.setProperty('opacity', '0', 'important');
    dwScrim.style.setProperty('pointer-events', 'none', 'important');
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
    if (!document.querySelector('.dw-drawer.is-open')) {
      document.body.classList.remove('has-open-drawer');
      dwHideScrim();
    }
  }

  function closeAllDrawers() {
    document.querySelectorAll('.dw-drawer.is-open').forEach(closeDrawer);
  }

  // Delegated click handler — progressive enhancement
  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const id = opener.getAttribute('data-drawer-open');
      const opened = openDrawer(id);
      if (opened) e.preventDefault();
      // If drawer doesn't exist, let the default link navigation happen
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      const drawer = closer.closest('.dw-drawer');
      closeDrawer(drawer);
      return;
    }
    if (e.target.classList && e.target.classList.contains('dw-drawer__backdrop')) {
      const drawer = e.target.closest('.dw-drawer');
      closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  // ---- Cart drawer: fetch + render ----
  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Pull the drawer's line-item HTML re-rendered by Liquid (Section Rendering
  // API). This is the ONLY source that knows on-hand inventory, so the qty caps,
  // disabled "+" buttons and "Max" notes always come from here — never from
  // hand-built JS markup (Shopify hides the stock number from /cart.js).
  function paintCartItems(sectionHtml) {
    const drawer = document.getElementById('DwCartDrawer');
    if (!drawer || !sectionHtml) return;
    const itemsEl = drawer.querySelector('[data-cart-items]');
    if (!itemsEl) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = sectionHtml;
    const fresh = tmp.querySelector('[data-cart-items]');
    if (fresh) itemsEl.innerHTML = fresh.innerHTML;
  }

  // Light sync — badge + totals only (no section fetch). Used on page load and
  // after off-drawer adds, so we don't pay for a section render on every page.
  function syncCartBadge() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function (err) { console.warn('DW cart fetch failed', err); });
  }

  // Full refresh — totals from /cart.js + inventory-aware items from Liquid.
  // Used whenever the drawer is open so the live stock cap is always accurate.
  function refreshCartDrawer() {
    const drawer = document.getElementById('DwCartDrawer');
    if (!drawer) return;
    Promise.all([
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch('/?sections=dw-cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; }),
    ])
      .then(function (res) {
        renderCartDrawer(res[0]);
        if (res[1] && res[1]['dw-cart-drawer']) paintCartItems(res[1]['dw-cart-drawer']);
        reconcileCartStock(); // pull any over-stock line back down to on-hand
      })
      .catch(function (err) { console.warn('DW cart fetch failed', err); });
  }

  // Reconcile any cart line that already exceeds on-hand stock down to the max.
  // Carts persist, so a line can hold more than we have (added before stock
  // dropped, or before this guard shipped — that's the "qty 12, only 4 in stock"
  // case). The Liquid-rendered drawer carries each line's real ceiling (data-max)
  // and key, so we read those, fix the overage in one atomic /cart/update.js,
  // re-render, and flag the corrected lines. Returns whether anything changed.
  function reconcileCartStock() {
    const drawer = document.getElementById('DwCartDrawer');
    if (!drawer) return Promise.resolve(false);
    const updates = {};
    const fixedKeys = [];
    drawer.querySelectorAll('[data-cart-items] [data-line][data-max][data-key]').forEach(function (li) {
      const max = parseInt(li.getAttribute('data-max'), 10);
      const span = li.querySelector('.dw-cart-drawer__qty span');
      const qty = parseInt(span ? span.textContent : '0', 10) || 0;
      const key = li.getAttribute('data-key');
      if (key && !isNaN(max) && qty > max) {
        updates[key] = max;
        fixedKeys.push(key);
      }
    });
    if (!fixedKeys.length) return Promise.resolve(false);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'dw-cart-drawer' }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        if (cart.sections && cart.sections['dw-cart-drawer']) paintCartItems(cart.sections['dw-cart-drawer']);
        // Make the correction visible: flash each fixed line + show its "Max" note.
        drawer.querySelectorAll('[data-cart-items] [data-key]').forEach(function (li) {
          if (fixedKeys.indexOf(li.getAttribute('data-key')) === -1) return;
          const box = li.querySelector('.dw-cart-drawer__qty');
          if (box) { box.classList.add('is-maxed'); setTimeout(function () { box.classList.remove('is-maxed'); }, 600); }
          const note = li.querySelector('[data-cart-qty-note]');
          if (note) note.hidden = false;
        });
        // Confirm the server actually applied the reduction before reloading the
        // cart page — guarantees a key mismatch can never cause a reload loop.
        const applied = (cart.items || []).every(function (it) {
          return !(it.key in updates) || it.quantity <= updates[it.key];
        });
        // On the full cart page the server-rendered table is now stale (still
        // shows the old quantity/total) — reload so it matches the fixed cart.
        if (applied && document.querySelector('.dw-cart__items')) window.location.reload();
        return true;
      })
      .catch(function (err) { console.warn('DW cart reconcile failed', err); return false; });
  }

  function renderCartDrawer(cart) {
    const drawer = document.getElementById('DwCartDrawer');
    if (!drawer) return;

    const hasItems = cart.item_count > 0;

    // Update badge in header (every page)
    document.querySelectorAll('.dw-header__cart-count').forEach(function (badge) {
      if (hasItems) {
        // Pulse only when the number actually CHANGES. This animation used to
        // run `infinite` in CSS whenever the cart was non-empty, which held a
        // compositor layer on every page and trained people to ignore the badge.
        // Same restart idiom as dwBumpCart() in dw-product.js.
        const changed = badge.textContent !== String(cart.item_count);
        badge.textContent = cart.item_count;
        badge.style.display = '';
        if (changed) {
          badge.classList.remove('is-bumped');
          void badge.offsetWidth; // force reflow so the animation replays
          badge.classList.add('is-bumped');
          badge.addEventListener('animationend', function () {
            badge.classList.remove('is-bumped');
          }, { once: true });
        }
      } else {
        badge.style.display = 'none';
      }
    });
    // Keep the drawer's own header count in sync (it was previously only
    // server-rendered, so it went stale after AJAX add/remove).
    const titleCount = drawer.querySelector('[data-cart-title-count]');
    if (titleCount) titleCount.textContent = cart.item_count;

    const itemsEl = drawer.querySelector('[data-cart-items]');
    const emptyEl = drawer.querySelector('[data-cart-empty]');
    const footerEl = drawer.querySelector('[data-cart-footer]');
    const promoEl = drawer.querySelector('[data-cart-promo]');
    const upsellEl = drawer.querySelector('[data-cart-upsell]');
    const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    const savingsEl = drawer.querySelector('[data-cart-savings]');
    const savingsAmtEl = drawer.querySelector('[data-cart-savings-amount]');
    const progressBar = drawer.querySelector('[data-shipping-fill]');
    const progressMsg = drawer.querySelector('[data-shipping-msg]');
    const stackEl = drawer.querySelector('[data-stack-save]');

    // ---- Empty vs. populated: mutually exclusive, single source of truth ----
    if (emptyEl) emptyEl.hidden = hasItems;
    if (footerEl) footerEl.hidden = !hasItems;
    if (promoEl) promoEl.hidden = !hasItems;
    if (upsellEl) upsellEl.hidden = !hasItems;

    // Items themselves are rendered by Liquid (see paintCartItems) so each line
    // carries its real inventory cap; here we only toggle the list's visibility.
    if (itemsEl) itemsEl.hidden = !hasItems;

    if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.items_subtotal_price);

    // Savings (line + cart-level discounts combined)
    if (savingsEl && savingsAmtEl) {
      const saved = (cart.original_total_price || 0) - (cart.total_price || 0);
      if (saved > 0) {
        savingsAmtEl.textContent = moneyFormat(saved);
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }

    // Free shipping progress
    if (progressBar && progressMsg) {
      const threshold = parseInt(drawer.dataset.freeShipping || '0', 10);
      if (threshold > 0) {
        // Heavy lines ship freight and can never unlock free shipping, so they
        // must not push the bar either. Counting a 5 gallon drum toward a
        // threshold it cannot satisfy would fill the bar to 100% and then quote
        // freight at checkout — which reads as the store having lied.
        // Cart API gives per-unit weight on each line as `grams`.
        const heavyCutoff = parseInt(drawer.dataset.heavyGrams || '4536', 10);
        let qualifying = 0;
        let heavyCount = 0;
        (cart.items || []).forEach(function (i) {
          if ((i.grams || 0) >= heavyCutoff) heavyCount += i.quantity;
          else qualifying += (i.final_line_price != null ? i.final_line_price : i.line_price) || 0;
        });

        const remaining = Math.max(0, threshold - qualifying);
        const pct = Math.min(100, (qualifying / threshold) * 100);
        progressBar.style.width = pct + '%';
        const remainingTpl = drawer.dataset.freeShippingRemaining || 'Add {amount} more for free shipping';
        const unlockedTpl = drawer.dataset.freeShippingUnlocked || 'You qualify for free shipping';
        const heavyNote = heavyCount
          ? '<span class="dw-drawer__ship-heavy">' + heavyCount + ' heavy ' +
            (heavyCount === 1 ? 'item ships' : 'items ship') +
            ' separately, quoted at checkout.</span>'
          : '';
        progressMsg.innerHTML =
          (remaining > 0
            ? remainingTpl.replace('{amount}', '<strong>' + moneyFormat(remaining) + '</strong>')
            : '<strong>' + unlockedTpl + '</strong>') + heavyNote;
        progressMsg.classList.toggle('is-unlocked', remaining === 0);
      }
    }

    // Stack & save
    if (stackEl) {
      let tiers = [];
      try { tiers = JSON.parse(stackEl.dataset.tiers || '[]'); } catch (e) {}
      let active = null;
      tiers.forEach(function (t) {
        if (cart.item_count >= t.qty && (!active || t.qty > active.qty)) active = t;
      });
      const labelEl = stackEl.querySelector('[data-stack-label]');
      if (labelEl) {
        if (active) {
          labelEl.textContent = active.label;
          stackEl.hidden = false;
        } else if (tiers.length > 0) {
          const next = tiers[0];
          const more = Math.max(0, next.qty - cart.item_count);
          labelEl.textContent = more > 0 ? 'Add ' + more + ' more: ' + next.label : next.label;
          stackEl.hidden = false;
        } else {
          stackEl.hidden = true;
        }
      }
    }
  }

  // Qty controls
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return; // "+" ships disabled at the cap (Liquid)

    const lineEl = btn.closest('[data-line]');
    const line = parseInt(btn.dataset.cartQty, 10);
    const delta = btn.dataset.delta != null ? parseInt(btn.dataset.delta, 10) : null;
    const set = btn.dataset.set != null ? parseInt(btn.dataset.set, 10) : null;
    const qtySpan = lineEl ? lineEl.querySelector('.dw-cart-drawer__qty span') : btn.parentElement.querySelector('span');
    const current = parseInt(qtySpan ? qtySpan.textContent : '1', 10) || 0;

    let quantity;
    if (set !== null && !isNaN(set)) {
      quantity = set;
    } else if (delta !== null && !isNaN(delta)) {
      quantity = Math.max(0, current + delta);
    } else return;

    // Hard cap: never let a line exceed on-hand stock. data-max is the tracked
    // inventory ceiling, written by Liquid (absent = no limit / backorder item).
    // This is the guarantee — it holds even if the server round-trip is skipped.
    const maxAttr = lineEl ? lineEl.getAttribute('data-max') : null;
    const max = maxAttr != null ? parseInt(maxAttr, 10) : null;
    if (max != null && quantity > max) {
      quantity = max;
      const qtyBox = lineEl.querySelector('.dw-cart-drawer__qty');
      if (qtyBox) { qtyBox.classList.add('is-maxed'); setTimeout(function () { qtyBox.classList.remove('is-maxed'); }, 600); }
      const note = lineEl.querySelector('[data-cart-qty-note]');
      if (note) note.hidden = false;
      if (quantity === current) return; // already at the ceiling — nothing to send
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'dw-cart-drawer' }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        if (cart.sections && cart.sections['dw-cart-drawer']) paintCartItems(cart.sections['dw-cart-drawer']);
        else refreshCartDrawer();
      })
      .catch(function (err) { console.warn('DW cart update failed', err); });
  });

  // Upsell quick-add inside the cart drawer
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.getAttribute('data-upsell-add');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function () { refreshCartDrawer(); })
      .catch(function (err) { console.warn('DW upsell add failed', err); })
      .finally(function () { btn.disabled = false; });
  });

  // Intercept any /cart/add form submission so the drawer opens on success
  // Uses *= (contains) to catch /cart/add, /cart/add.js, ?return_to=… etc.
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const drawer = document.getElementById('DwCartDrawer');
    if (!drawer) return;

    e.preventDefault();
    const fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (res) {
        if (!res.ok) throw new Error('ATC failed');
        openDrawer('DwCartDrawer');
      })
      .catch(function (err) {
        console.warn('DW ATC failed', err);
        form.submit();
      });
  });

  // Silent sync hook — other scripts (e.g. card qty steppers) mutate the cart
  // and fire this. If the drawer is open, do a full inventory-aware refresh so
  // the caps stay live; otherwise just sync the badge/totals (skip the section
  // render for speed — the drawer re-fetches items when it next opens).
  document.addEventListener('dw:cart:updated', function () {
    const drawer = document.getElementById('DwCartDrawer');
    if (drawer && drawer.classList.contains('is-open')) refreshCartDrawer();
    else syncCartBadge();
  });

  // Initial sync: first reconcile any over-stock line down to on-hand (fixes
  // carts that already hold more than we have, and corrects the header count);
  // if nothing needed fixing, just sync the badge/totals.
  function dwInitCartSync() {
    reconcileCartStock().then(function (changed) {
      if (!changed) syncCartBadge();
    });
  }
  if (document.readyState !== 'loading') {
    dwInitCartSync();
  } else {
    document.addEventListener('DOMContentLoaded', dwInitCartSync);
  }

  // ---- Email popup ----
  const popup = document.getElementById('DwEmailPopup');
  if (popup) {
    const STORAGE_KEY = 'dw_email_popup_seen';
    const trigger = popup.dataset.trigger || 'delay';
    const delay = parseInt(popup.dataset.delay || '6', 10) * 1000;
    const frequencyDays = parseInt(popup.dataset.frequency || '7', 10);

    function recentlySeen() {
      try {
        const ts = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
        if (!ts) return false;
        const days = (Date.now() - ts) / (1000 * 60 * 60 * 24);
        return days < frequencyDays;
      } catch (e) {
        return false;
      }
    }
    function markSeen() {
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
    }
    function openPopup() {
      if (popup.classList.contains('is-open')) return;
      // Don't fight a drawer for attention
      if (document.querySelector('.dw-drawer.is-open')) return;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      markSeen();
    }
    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
    }

    // If the form posted successfully, the popup re-renders with the success
    // message — keep it open so the user sees it, but mark as seen.
    if (popup.querySelector('.dw-email-popup__success')) {
      openPopup();
    } else if (!recentlySeen()) {
      if (trigger === 'delay') {
        setTimeout(openPopup, delay);
      } else if (trigger === 'scroll') {
        const onScrollDepth = function () {
          const scrolled = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
          if (scrolled > 0.5) {
            openPopup();
            window.removeEventListener('scroll', onScrollDepth);
          }
        };
        window.addEventListener('scroll', onScrollDepth, { passive: true });
      } else if (trigger === 'exit') {
        // Desktop: exit intent. Mobile (no mouseleave): fall back to delay.
        const isTouch = window.matchMedia('(hover: none)').matches;
        if (isTouch) {
          setTimeout(openPopup, Math.max(delay, 8000));
        } else {
          const onExit = function (e) {
            if (e.clientY <= 0) {
              openPopup();
              document.removeEventListener('mouseout', onExit);
            }
          };
          document.addEventListener('mouseout', onExit);
        }
      }
    }

    // Close handlers (backdrop, close button, dismiss link)
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close]') || (e.target.classList && e.target.classList.contains('dw-modal__backdrop'))) {
        e.preventDefault();
        closePopup();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });
  }

  // ---- Scroll reveal (perf-safe: transform/opacity only, below-fold only) ----
  // Above-the-fold elements are skipped entirely so the hero/LCP paints instantly
  // and there's no CLS. Honors prefers-reduced-motion. No library, native IO.
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var SELECTOR = [
      '.dw-section-header',
      '.dw-product-card',
      '.dw-category-tile',
      '.dw-job-card',
      '.dw-brand-tile',
      '.dw-step',
      '.dw-testimonial',
      '.dw-community__card',
      '.dw-faq__item',
      '.dw-image-text__media',
      '.dw-image-text__content',
      '.dw-cta-banner__inner',
      '.dw-blog-card',
      '.dw-product-related__list > li',
      '.dw-wholesale__benefits > li',
      // Added 2026-08-11. Adding a selector here is the cheapest way to make a
      // component feel considered: it inherits the reduced-motion bail, the
      // above-fold LCP skip, auto-unobserve and the stagger, at zero extra cost.
      //
      // NOT .dw-pol — the polaroids position themselves with
      // `transform: translateY(var(--lift)) rotate(var(--tilt))`, and
      // `.dw-reveal--in` sets `transform: none`, which would flatten every
      // tilt in the strip. Anything that owns its own transform must stay out
      // of this list.
      '.dw-product-specs__row',
      '.dw-supply__card',
      '.dw-coltile',
      '.dw-locator__card'
    ].join(',');

    function initReveal() {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('dw-reveal--in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      var vh = window.innerHeight || document.documentElement.clientHeight;
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        // Skip anything already in (or near) the first viewport — protects LCP/CLS
        if (el.getBoundingClientRect().top < vh) return;
        el.classList.add('dw-reveal');
        // Gentle stagger for items sharing a parent (grids, lists)
        if (el.parentElement) {
          var idx = Array.prototype.indexOf.call(el.parentElement.children, el);
          if (idx > 0) el.style.transitionDelay = Math.min(idx, 6) * 55 + 'ms';
        }
        io.observe(el);
      });
    }

    if (document.readyState !== 'loading') initReveal();
    else document.addEventListener('DOMContentLoaded', initReveal);
  })();

  /* ---- Count-up, bar fill and the hero shine ------------------------------
     A second, tiny observer rather than a branch inside the reveal one: these
     elements are usually ABOVE the fold (the rewards bar, the hero), and the
     reveal observer deliberately skips anything in the first viewport to protect
     LCP. Sharing it would either break that guarantee or never fire.

     Everything here degrades to the true value. The real number is what the
     server rendered; JS only overwrites it mid-animation and always lands on the
     original. If this code never runs, the page is still correct. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (!window.DwMotion || !window.DwMotion.celebrate) return;

    function countUp(el) {
      var target = parseFloat(String(el.textContent).replace(/[^0-9.]/g, ''));
      if (!isFinite(target) || target <= 0) return;
      var decimals = (String(el.textContent).split('.')[1] || '').replace(/[^0-9]/g, '').length;
      var prefix = String(el.textContent).match(/^[^0-9]*/)[0];
      var suffix = String(el.textContent).match(/[^0-9.]*$/)[0];
      var start = null;
      var DUR = 700;

      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / DUR);
        // easeOutCubic — fast then settling, so the final value is readable
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(frame);
      }
      el.textContent = prefix + (0).toFixed(decimals) + suffix;
      requestAnimationFrame(frame);
    }

    function fillBar(el) {
      var end = el.style.width;
      if (!end) return;
      el.style.width = '0%';
      // Double rAF so the 0% is actually painted before the transition starts —
      // same trick dwFlyToCart uses in dw-product.js.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.style.width = end; });
      });
    }

    var TARGETS = [
      ['.dw-rewards__stat-num', countUp],
      ['.dw-rewards-balance__num', countUp],
      ['.dw-token-earn__count', countUp],
      ['.dw-refund__bar-fill', fillBar],
      // FIRST slide only. The hero is the LCP element and a full-width moving
      // gradient is fill-rate work — the one thing a low-end Adreno GPU has
      // least of. So: one slide, desktop only (the CSS gates at 750px), skipped
      // entirely on Save-Data, and delayed past the LCP window. If the frame
      // timeline moves at all on the test Android, delete this line — it is the
      // most decorative thing in the programme and buys nothing functional.
      ['.dw-hero-banner__slide:first-child', function (el) { el.classList.add('dw-shine'); }]
    ];

    function init() {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var fn = entry.target.__dwOnSeen;
          io.unobserve(entry.target);
          if (fn) { try { fn(entry.target); } catch (e) {} }
        });
      }, { threshold: 0.35 });

      TARGETS.forEach(function (pair) {
        document.querySelectorAll(pair[0]).forEach(function (el) {
          el.__dwOnSeen = pair[1];
          io.observe(el);
        });
      });
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  /* ---- Easter egg: squeegee the header clean ------------------------------
     Five taps on the logo inside two seconds wipes a shine across the chrome
     and pops a burst. Undiscoverable by accident (a real navigation click fires
     on the first tap and leaves the page), memorable when someone finds it.

     Deliberately does NOT preventDefault: the logo stays a working home link at
     all times. The counter only ever completes if you're already home, or if
     you're tapping fast enough that navigation hasn't committed — which is
     exactly the "someone is messing about" case we want to reward. */
  (function () {
    var logo = document.querySelector('.dw-header__logo');
    var wrap = document.getElementById('DwHeaderWrap');
    if (!logo || !wrap) return;

    var taps = 0;
    var timer = null;

    logo.addEventListener('click', function () {
      if (!window.DwMotion || !window.DwMotion.celebrate) return;
      taps++;
      clearTimeout(timer);
      timer = setTimeout(function () { taps = 0; }, 2000);
      if (taps < 5) return;

      taps = 0;
      wrap.classList.remove('dw-wiped');
      void wrap.offsetWidth; // restart the sweep
      wrap.classList.add('dw-wiped');
      wrap.addEventListener('animationend', function () {
        wrap.classList.remove('dw-wiped');
      }, { once: true });

      if (window.DwBurst) window.DwBurst(logo, { count: 12, variant: 'gold' });
      if (window.DwSfx) window.DwSfx.win();
      if (window.DwTap) window.DwTap('reward');
    });
  })();

  // ---- Hero banner carousel (scroll-snap; native swipe, JS for arrows/dots/autoplay) ----
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var slides = root.querySelectorAll('[data-carousel-slide]');
      if (!track || slides.length < 2) return;

      var dots = root.querySelectorAll('[data-carousel-dot]');
      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      var current = 0;
      var timer = null;

      function setDots(i) {
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      function goTo(i, smooth) {
        current = (i + slides.length) % slides.length;
        track.scrollTo({
          left: slides[current].offsetLeft,
          behavior: smooth === false ? 'auto' : 'smooth',
        });
        setDots(current);
      }

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); stop(); start(); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); stop(); start(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.index, 10) || 0);
          stop(); start();
        });
      });

      // Keep dots in sync when the user swipes/scrolls manually
      var scrollRaf;
      track.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) { current = i; setDots(current); }
        });
      }, { passive: true });

      // Autoplay (paused on hover/focus/touch, disabled for reduced motion)
      var autoplay = root.dataset.autoplay === 'true' && !reduced;
      var interval = (parseInt(root.dataset.interval, 10) || 5) * 1000;
      function start() {
        if (!autoplay || timer) return;
        timer = setInterval(function () { goTo(current + 1); }, interval);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('touchstart', stop, { passive: true });
      // Pause when tab is hidden to save resources
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      start();
    });
  })();

  // ---- Account dropdown: close on outside-click / Escape ----
  // The menu is a native <details data-account-menu> so it works without JS;
  // this just adds the expected "click away to dismiss" behavior.
  (function () {
    function closeAll(except) {
      document.querySelectorAll('details[data-account-menu][open]').forEach(function (d) {
        if (d !== except) d.removeAttribute('open');
      });
    }
    document.addEventListener('click', function (e) {
      var open = document.querySelector('details[data-account-menu][open]');
      if (open && !open.contains(e.target)) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = document.querySelector('details[data-account-menu][open]');
        if (open) {
          closeAll();
          var summary = open.querySelector('summary');
          if (summary) summary.focus();
        }
      }
    });
  })();
})();
